import keyMirror from 'keymirror';

export default keyMirror({
  SET_ALL_PLAYER_SRC: undefined,
  SET_INITIAL_PLAYER_SRC: undefined,
  SET_CURRENT_PLAYER_SRC: undefined,
  UPDATE_ALL_PLAYER_SRC: undefined,

  UPDATE_SEEK_POSITION: undefined,
  UNSET_TUTORIAL: undefined,

  REQUEST_CAM_UNIT: undefined,
  REQUEST_CAM_LIST: undefined,
  SET_CAM_LIST: undefined,
  GET_CAM_LIST: undefined,

  UPDATE_EVENT_STATUS: undefined,
  UPDATE_CURRENT_EVENT: undefined,

  UPDATE_CAM_ID: undefined,
  MATCH_CAM_ID: undefined,

  UPDATE_VENUE_DATETIME: undefined,
  UPDATE_USER_DATETIME: undefined,

  SET_DONATIONS: undefined,
});
